module.exports = __webpack_public_path__ + "img/9.efe64498.jpg";